// extracted by mini-css-extract-plugin
export var banner = "_j1-0";
export var closeButton = "_j1-2";
export var greenCheckmark = "_j1-3";
export var hereLink = "_j1-4";
export var titleIcon = "_j1-1";